import Card from '../Card'

export default class Exit extends Card {
  name = 'Exit'

  constructor() {
    super()
  }

  pick(picker = this.board!.hero.card) {
    if (!super.pick(picker)) return false

    const hero = this.board!.hero
    if (picker === hero.card) {
      this.nextFloor()
      return true
    }

    return false
  }

  nextFloor() {
    this.board!.game.nextBoard()
  }

  clone(): Card {
    return new Exit()
  }
}
